var React = require('react');

function ArrowOrangeR (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},[React.createElement("path",{"id":"a","d":"M557.4 1415.03l2.13-2.13 7.07 7.07-2.13 2.13z","key":0}),React.createElement("path",{"id":"b","d":"M557.4 1424.97l2.13 2.13 7.07-7.07-2.13-2.13z","key":1})]),React.createElement("use",{"xlinkHref":"#a","transform":"translate(-557 -1413)","key":1}),React.createElement("use",{"xlinkHref":"#b","transform":"translate(-557 -1413)","key":2})]);
}

ArrowOrangeR.defaultProps = {"width":"10","height":"14","className":"icon"};

module.exports = ArrowOrangeR;

ArrowOrangeR.default = ArrowOrangeR;
